// extracted by mini-css-extract-plugin
export var bottom_cta_btn = "index-module--bottom_cta_btn--8cc25";
export var btn_wrapper = "index-module--btn_wrapper--9e1f2";
export var content_btn = "index-module--content_btn--1af2d";
export var content_desc = "index-module--content_desc--75d0b";
export var content_title = "index-module--content_title--7c367";
export var content_wrapper = "index-module--content_wrapper--dccf1";
export var cover_wrapper = "index-module--cover_wrapper--1ea95";
export var cta_btn_item = "index-module--cta_btn_item--4cbc8";
export var cta_btn_item_wrapper = "index-module--cta_btn_item_wrapper--afe94";
export var feature_item = "index-module--feature_item--0e895";
export var feature_item_content_wrapper = "index-module--feature_item_content_wrapper--cc5d9";
export var feature_item_cover = "index-module--feature_item_cover--adbf2";
export var inner = "index-module--inner--6cc51";
export var left_part = "index-module--left_part--373ed";
export var new_tag = "index-module--new_tag--9d772";
export var swiper_bullet = "index-module--swiper_bullet--a92a2";
export var swiper_bullet_active = "index-module--swiper_bullet_active--62a5f";
export var swiper_self = "index-module--swiper_self--bedd5";
export var swiper_wrapper = "index-module--swiper_wrapper--eb144";
export var tips_text = "index-module--tips_text--fcdee";
export var wrapper = "index-module--wrapper--431c6";